import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import { SunIcon, MoonIcon, ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const {
    theme,
    toggleTheme
  } = useTheme();
  const {
    language,
    t,
    getPath
  } = useLanguage();
  const [isLangMenuOpen, setIsLangMenuOpen] = useState(false);
  const handleLanguageChange = (lang: 'en' | 'ru' | 'ua' | 'pl') => {
    const currentPath = window.location.pathname;
    let newPath = currentPath;
    // Remove existing language prefix
    if (currentPath.startsWith('/ru')) {
      newPath = currentPath.substring(3) || '/';
    } else if (currentPath.startsWith('/ua')) {
      newPath = currentPath.substring(3) || '/';
    } else if (currentPath.startsWith('/uk')) {
      // Handle legacy 'uk' prefix
      newPath = currentPath.substring(3) || '/';
    } else if (currentPath.startsWith('/pl')) {
      newPath = currentPath.substring(3) || '/';
    }
    // Add new language prefix if not English
    if (lang === 'ru') {
      newPath = `/ru${newPath === '/' ? '' : newPath}`;
    } else if (lang === 'ua') {
      newPath = `/ua${newPath === '/' ? '' : newPath}`;
    } else if (lang === 'pl') {
      newPath = `/pl${newPath === '/' ? '' : newPath}`;
    }
    window.location.href = newPath;
  };
  return <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl" style={{
    backgroundColor: 'var(--bg-primary)' + 'CC',
    borderBottom: '1px solid var(--border)'
  }} data-id="element-173">
      <div className="max-w-xxl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-5 flex items-center justify-between" data-id="element-174">
        {/* Logo */}
        <a href={getPath('')} className="flex items-center gap-1" data-id="element-175">
          <span className="text-xl sm:text-2xl font-bold tracking-tight" style={{
          color: 'var(--text-primary)'
        }} data-id="element-176">
            X
          </span>
          <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full" style={{
          backgroundColor: 'var(--accent)'
        }} data-id="element-177" />
        </a>

        <div className="flex items-center gap-2 sm:gap-4" data-id="element-178">
          {/* Language Dropdown */}
          <div className="relative" data-id="element-179">
            <button onClick={() => setIsLangMenuOpen(!isLangMenuOpen)} className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg border text-sm font-medium transition-all" style={{
            borderColor: 'var(--border)',
            backgroundColor: 'var(--bg-secondary)',
            color: 'var(--text-primary)'
          }} data-id="element-180">
              <span className="uppercase" data-id="element-181">{language}</span>
              <ChevronDownIcon className="w-3 h-3 sm:w-4 sm:h-4" style={{
              color: 'var(--text-muted)'
            }} data-id="element-182" />
            </button>

            <AnimatePresence data-id="element-183">
              {isLangMenuOpen && <>
                  <div className="fixed inset-0 z-40" onClick={() => setIsLangMenuOpen(false)} data-id="element-184" />
                  <motion.div initial={{
                opacity: 0,
                y: -10
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -10
              }} transition={{
                duration: 0.2
              }} className="absolute top-full mt-2 right-0 rounded-lg border overflow-hidden shadow-lg min-w-[80px] z-50" style={{
                backgroundColor: 'var(--bg-secondary)',
                borderColor: 'var(--border)'
              }} data-id="element-185">
                    {['en', 'ru', 'ua', 'pl'].map(lang => <button key={lang} onClick={() => handleLanguageChange(lang as 'en' | 'ru' | 'ua' | 'pl')} className="w-full px-4 py-2 text-left text-sm font-medium transition-colors" style={{
                  backgroundColor: language === lang ? 'var(--accent)' : 'transparent',
                  color: language === lang ? '#FFFFFF' : 'var(--text-primary)'
                }} data-id="element-186">
                        {lang.toUpperCase()}
                      </button>)}
                  </motion.div>
                </>}
            </AnimatePresence>
          </div>

          {/* Theme Toggle */}
          <button onClick={toggleTheme} className="p-2 sm:p-2.5 rounded-lg border transition-all hover:scale-105" style={{
          borderColor: 'var(--border)',
          backgroundColor: 'var(--bg-secondary)'
        }} aria-label="Toggle theme" data-id="element-187">
            {theme === 'dark' ? <SunIcon className="w-4 h-4 sm:w-5 sm:h-5" style={{
            color: 'var(--accent)'
          }} data-id="element-188" /> : <MoonIcon className="w-4 h-4 sm:w-5 sm:h-5" style={{
            color: 'var(--accent)'
          }} data-id="element-189" />}
          </button>

          {/* CTA Button */}
          <a href={getPath('#consultation')} className="px-3 sm:px-6 py-2 sm:py-3 rounded-lg text-xs sm:text-sm font-semibold transition-all hover:scale-105 whitespace-nowrap" style={{
          backgroundColor: 'var(--accent)',
          color: '#FFFFFF'
        }} data-id="element-190">
            {t('nav.getStarted')}
          </a>
        </div>
      </div>
    </nav>;
}